<div *ngIf="hasHotelViewCount" class="hotel-views-count">
  {{ hotelViewCount }}<span class="hint">{{ messages.hotelViewCount }}</span>
</div>
